export default __webpack_public_path__ + "static/media/edit.f03de22e.svg";